import { createEvent } from "@cobuildlab/react-simple-state";

export const OnFetchReport = createEvent();
export const OnFetchReportError = createEvent();
